import { useMutation } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

import { makeResourceKeys } from '../../makeResources/makeResourcesKeys';
import useInvalidateStores from '../../useInvalidateStores';

const keys = makeResourceKeys('patients');

type Data = {
  idToKeep: string;
  idsToTrash: string[];
  source?: string;
};

type Response = {
  user: string;
};

const patientMerge = async (data: Data) => {
  const response = await axiosClient.post('patients/merge', data);
  return response.data as Response;
};

export default function usePatientMerge() {
  const invalidateStores = useInvalidateStores();

  const userQuery = useMutation(patientMerge, {
    onSuccess: () => invalidateStores(keys.$all, 'Patient'),
  });
  return userQuery;
}
